/***********************************************
  IceMedX - Developed By IceMedx Corporation
  Copyright 2023 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class paytoindex extends IceEntity {
  pay_to_index_key: string = "";
  pay_to_key: string = "";
  pay_date: any = NaN;
  pay_to_name: string = "";
  pay_from_name: string = "";
  from_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  from_trans_account: string = "";
  to_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  to_trans_account: string = "";
  pay_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  created: any = NaN;
  modified: any = NaN;

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAY_TO_INDEX";
  }
}
